<template>
  <div>
    <comment-form :customer="customer"></comment-form>
    <v-card v-if="Comments.length > 0" class="mt-3" :class="heightClass">
      <comment-card
        v-for="(comment, index) in orderedComments"
        :key="comment.id"
        :index="index"
        :comment="comment"
        :total="Comments.length"
      ></comment-card>
    </v-card>
    <v-subheader v-else>No comments</v-subheader>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import CommentCard from './CommentCard';
import CommentForm from './CommentForm';

export default {
  name: 'comment-list',
  components: { CommentCard, CommentForm },
  props: {
    customer: {
      type: Object,
      default: null
    },
    referral: {
      type: Boolean,
      default: false
    },
    dialler: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({}),
  computed: {
    ...mapGetters(['UserHasRole', 'Comments', 'LoadingComments']),
    orderedComments() {
      return _.orderBy(this.Comments, ['created_at'], ['desc']);
    },
    heightClass() {
      if (this.dialler && this.referral !== null) {
        return 'dialler-referral-height';
      } else if (this.dialler) {
        return 'dialler-customer-height';
      }
      return '';
    }
  },
  methods: {
    ...mapActions(['getComments'])
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-text-field__details {
  display: none !important;
}
::v-deep .selected {
  background-color: #eee;
}
::v-deep .theme--light .v-list .v-list__tile--link:hover {
  border-radius: 0 !important;
}

.dialler-customer-height {
  height: calc(97vh - 339px);
  max-height: calc(97vh - 339px);
  overflow-y: auto;
}

.dialler-referral-height {
  height: calc(97vh - 277px);
  max-height: calc(97vh - 277px);
  overflow-y: auto;
}
</style>
